import { DiscordSDK, patchUrlMappings } from '@discord/embedded-app-sdk';

// Application ID do app no Discord Developer Portal. Identificador publico
// (aparece na URL da activity); o env serve para override em outros ambientes.
const clientId = import.meta.env.VITE_DISCORD_CLIENT_ID || '279436351538200578';

export function applyUrlMappings(): void {
  const wsServerUrl = import.meta.env.VITE_WS_SERVER_URL;
  if (!wsServerUrl) return;

  try {
    const url = new URL(wsServerUrl);
    const target = `${url.host}`;
    patchUrlMappings([
      {
        prefix: '/ws-proxy/',
        target,
      },
    ]);
    console.log('[discord] url mappings aplicados', {
      prefix: '/ws-proxy/',
      target,
    });
  } catch (e) {
    console.warn('[discord] falha ao aplicar url mappings', e);
  }
}

export function isDiscordActivity(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.has('frame_id') || params.has('instance_id');
  } catch {
    return false;
  }
}

export function getWsUrl(): string {
  const base = import.meta.env.VITE_WS_SERVER_URL || 'wss://activity.ikx-server.com/ws';
  if (isDiscordActivity()) {
    const url = new URL(base);
    const protocol = url.protocol === 'wss:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws-proxy${url.pathname}`;
  }
  return base;
}

let sdkPromise: Promise<DiscordSDK | null> | null = null;

// Instancia unica por pagina: criar um segundo DiscordSDK no mesmo frame
// quebra o handshake RPC. Retorna null quando VITE_DISCORD_CLIENT_ID nao foi
// configurado no build.
export function getDiscordSdk(): Promise<DiscordSDK | null> {
  if (!sdkPromise) {
    sdkPromise = initDiscordSdk();
  }
  return sdkPromise;
}

export async function initDiscordSdk(): Promise<DiscordSDK | null> {
  if (!clientId) return null;
  const discordSdk = new DiscordSDK(clientId);
  await discordSdk.ready();
  return discordSdk;
}
